import { BLOCKS } from '@contentful/rich-text-types'
import React from 'react'
import { GatsbyImage } from 'gatsby-plugin-image'
import { renderTextWithLineBreaks } from './TextWithLineBreak'

export const blogPostOptions = linkReadMore => {
  return {
    renderNode: {
      [BLOCKS.PARAGRAPH]: (node, children) => (
        <p className="blog-post--body" key={JSON.stringify(node)}>
          {children}
          {linkReadMore}
        </p>
      )
    }
  }
}

export const contactHourOptions = () => {
  return {
    renderNode: {
      [BLOCKS.PARAGRAPH]: (node, children) => <p className="list">{children}</p>
    }
  }
}

export const subtextOptions = (isBlog, blog, subTextClass, blogLink) => {
  return {
    renderNode: {
      [BLOCKS.PARAGRAPH]: (node, children) => {
        const ellipsisClass = isBlog || blog ? 'blog-ellipsis' : 'ellipsis'
        return (
          <>
            <p className={`${subTextClass} ${ellipsisClass}`}>{children}</p>
            {blogLink}
          </>
        )
      }
    },
    renderText: text => {
      const convertedText = renderTextWithLineBreaks(text)
      return convertedText
    }
  }
}

export const annualFeeOptions = () => {
  return {
    renderNode: {
      [BLOCKS.PARAGRAPH]: (node, children) => (
        <>
          <p className="annualFeeNotice">{children}</p>
          <br />
        </>
      )
    }
  }
}

export const blogBodyOptions = () => {
  return {
    renderNode: {
      [BLOCKS.PARAGRAPH]: (node, children) => <p>{children}</p>,
      [BLOCKS.EMBEDDED_ASSET]: node => {
        const { title, gatsbyImageData, description } = node.data.target

        let alignPicture
        if (description === 'left') {
          alignPicture = 'float-left'
        }
        if (description === 'right') {
          alignPicture = 'float-right'
        }

        return (
          <GatsbyImage
            className={`${alignPicture}`}
            image={gatsbyImageData}
            aria-label={title}
            alt={title}
          />
        )
      }
    }
  }
}
